export const PAYMENTS_TABLE_COLUMNS = [
  { id: 'payment_date', label: 'Fecha Pago/Factura', minWidth: 120 },
  { id: 'coupons_count', label: 'Cupones', minWidth: 60 },
  { id: 'collector_entity', label: 'Entidad Rec.', minWidth: 120 },
  { id: 'invoice_range', label: 'Facturas desde-hasta', minWidth: 120 },
  { id: 'total_coupon_amount', label: 'Total Cupon', minWidth: 120 },
  { id: 'total_invoiced_amount', label: 'Total Facturado', minWidth: 120 },
  { id: 'actions', label: 'Acciones', minWidth: 80 },
];

/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;
